module.exports = "<svg viewBox=\"0 0 27.3 19.1\"><path d=\"M25.8 11.1H6.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h19.1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z\"></path><path d=\"M25.8 11.1H6.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h19.1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm0 8H6.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h19.1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm0-16.1H1.5C.7 3 0 2.3 0 1.5S.7 0 1.5 0h24.3c.8 0 1.5.7 1.5 1.5S26.6 3 25.8 3z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/menu.svg
// module id = 309
// module chunks = 1